import { render, staticRenderFns } from "./staffRecord.vue?vue&type=template&id=4f7f07f3&"
import script from "./staffRecord.vue?vue&type=script&lang=js&"
export * from "./staffRecord.vue?vue&type=script&lang=js&"
import style0 from "./staffRecord.vue?vue&type=style&index=0&id=4f7f07f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports